export default class ReviewBarRating {
  constructor() {
    if (ReviewBarRating.exists) {
      return ReviewBarRating.instance;
    }

    ReviewBarRating.instance = this;
    ReviewBarRating.exists = true;

    this.ratingIndicatorsValueEl = document.querySelectorAll('#bar-rating-value-indicators a');
    this.ratingIndicatorsValue1El = document.querySelectorAll('#bar-rating-value1-indicators a');
    this.ratingIndicatorsValue2El = document.querySelectorAll('#bar-rating-value2-indicators a');
    this.ratingIndicatorsValueQualityEl = document.querySelectorAll('#bar-rating-quality-indicators a');

    this.indicators = [];
    this.attachHandlers();
  }

  attachHandlers() {
    this.addEvent();
  }

  addEvent() {
    if (this.ratingIndicatorsValueEl) {
      this.ratingIndicatorsValueEl.forEach(indicator => {
        indicator.addEventListener('click', this.barRatingChange.bind(this));
        indicator.addEventListener('click', this.barRatingActive.bind(this));
        indicator.addEventListener('mouseenter', this.barRatingHover.bind(this));
        indicator.addEventListener('mouseleave', this.barRatingHover.bind(this));
      });
    }

    if (this.ratingIndicatorsValue1El) {
      this.ratingIndicatorsValue1El.forEach(indicator => {
        indicator.addEventListener('click', this.barRatingChange.bind(this));
        indicator.addEventListener('click', this.barRatingActive.bind(this));
        indicator.addEventListener('mouseenter', this.barRatingHover.bind(this));
        indicator.addEventListener('mouseleave', this.barRatingHover.bind(this));
      });
    }

    if (this.ratingIndicatorsValue2El) {
      this.ratingIndicatorsValue2El.forEach(indicator => {
        indicator.addEventListener('click', this.barRatingChange.bind(this));
        indicator.addEventListener('click', this.barRatingActive.bind(this));
        indicator.addEventListener('mouseenter', this.barRatingHover.bind(this));
        indicator.addEventListener('mouseleave', this.barRatingHover.bind(this));
      });

      if (this.ratingIndicatorsValueQualityEl) {
        this.ratingIndicatorsValueQualityEl.forEach(indicator => {
          indicator.addEventListener('click', this.barRatingChange.bind(this));
          indicator.addEventListener('click', this.barRatingActive.bind(this));
          indicator.addEventListener('mouseenter', this.barRatingHover.bind(this));
          indicator.addEventListener('mouseleave', this.barRatingHover.bind(this));
        });
      }
    }
  }

  barRatingChange(event) {
    event.preventDefault();

    let barEl = event.target;
    let rating = barEl.dataset.barRating;

    if (!barEl.dataset.triggerId) {
      return;
    }

    switch (barEl.dataset.triggerId) {
      case 'value':
        ReviewBarRating.triggerSelectRatingValue(rating);
        break
      case 'value1':
        ReviewBarRating.triggerSelectRatingValue1(rating);
        break
      case 'value2':
        ReviewBarRating.triggerSelectRatingValue2(rating);
        break
      case 'quality':
        ReviewBarRating.triggerSelectRatingValueQuality(rating);
        break
    }
  }

  barRatingActive(event) {
    let barEl = event.target;
    let container = barEl.closest('.indicators');

    [...barEl.parentElement.children].forEach(el => {
      el.classList.remove('active');
    });
    barEl.classList.add('active');
    container.classList.add('selected');
  }

  barRatingHover(event) {
    const action = event.type === 'mouseenter' ? 'add' : 'remove';
    let barEl = event.target;

    if (!barEl || !barEl.classList || typeof barEl.classList[action] !== "function") {
      return;
    }

    let prev = barEl.previousElementSibling;
    let rating = barEl.dataset.rating;

    barEl.classList[action]('hover');

    this.indicators.forEach((item, index) => {
      if ('mouseleave' === event.type) {
        item.classList.remove('selected');
      } else {
        if (rating && index === parseInt(rating) - 1) {
          item.classList.add('selected')
        } else {
          item.classList.remove('selected')
        }
      }
    });

    while (prev) {
      prev.classList[action]('hover');
      prev = prev.previousElementSibling;
    }
  }

  static triggerSelectRatingValue(selector) {
    let select = document.querySelector('[name="rating_value"]');

    if (!select) {
      return;
    }

    select.value = selector;
    select.dispatchEvent(new Event('change', {bubbles: true}));
  }

  static triggerSelectRatingValue1(selector) {
    let select = document.querySelector('[name="rating_value1"]');

    if (!select) {
      return;
    }

    select.value = selector;
    select.dispatchEvent(new Event('change', {bubbles: true}));
  }

  static triggerSelectRatingValue2(selector) {
    let select = document.querySelector('[name="rating_value2"]');

    if (!select) {
      return;
    }

    select.value = selector;
    select.dispatchEvent(new Event('change', {bubbles: true}));
  }

  static triggerSelectRatingValueQuality(selector) {
    let select = document.querySelector('[name="rating_quality"]');

    if (!select) {
      return;
    }

    select.value = selector;
    select.dispatchEvent(new Event('change', {bubbles: true}));
  }
}
